import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {  changeCurrProd, getCatalog } from "../../../redux/slices/catalogSlice";
import Product from "./Product";
import { decodeProductName } from "../../../utils/utils/urlHelper";

const ProductContainer = (props) => {
  const { productId } = useParams();
  const dispatch = useDispatch();
  const {catalog, underCatalog, activeDevice, currentCatalog } = useSelector(state => state.catalog) 
 
 
 useEffect(() => {
    if (productId) {

     // dispatch(getOneDevice(decodeProductName(productId))); // Загружаем данные товара
    dispatch(changeCurrProd(decodeProductName(productId))) 
    }
  }, [productId, dispatch]);
  
useEffect(() => {
  if(!currentCatalog[0]) dispatch(getCatalog)
  
    else if (!currentCatalog[0] && underCatalog[0]) {
      const index = catalog.indexOf(activeDevice.catalog)

      underCatalog[index].forEach((el, i) => {
    
         if(el.name === activeDevice.underCatalog) {

          dispatch(currentCatalog([index, i, 1]))
               
        }
        
      }
 
    )

    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentCatalog, underCatalog]) 



   if(props.mobile === "mobile")  return <Product mobile="mobile"/>
   else return <Product />
};

export default ProductContainer;
